// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4891) return "static/css/4891.3ba2c747c945fe1621af.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "4f767f2564a62b1968c8" + ".chunk.css";
};